import React from 'react';
import { Zap, Shield, DollarSign } from 'lucide-react';

export const HowItWorks = () => {
  const features = [
    {
      icon: Zap,
      title: 'Automated Optimization',
      description: 'Our algorithms constantly monitor rates and automatically shift your funds to the highest-yielding accounts.',
      color: 'blue'
    },
    {
      icon: Shield,
      title: 'FDIC Insured Security',
      description: 'Your funds are held in program banks that are FDIC insured up to $250,000 per depositor.',
      color: 'emerald'
    },
    {
      icon: DollarSign,
      title: 'Zero Hidden Fees',
      description: 'We don\'t charge maintenance fees or transaction fees. Keep 100% of the interest you earn.',
      color: 'purple'
    }
  ];

  const colorClasses = {
    blue: 'bg-blue-50 text-blue-600',
    emerald: 'bg-emerald-50 text-emerald-600',
    purple: 'bg-purple-50 text-purple-600'
  };

  return (
    <section id="features" className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase mb-2">Why Saverr?</h2>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">A smarter way to grow your cash.</h2>
          <p className="text-lg text-slate-600">
            We analyze hundreds of banks daily to ensure your deposits are always earning the highest yield available, without the headache of switching banks manually.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div key={index} className="bg-white rounded-2xl p-8 shadow-sm border border-slate-100 hover:shadow-md transition-shadow">
                <div className={`w-14 h-14 ${colorClasses[feature.color]} rounded-xl flex items-center justify-center mb-6`}>
                  <Icon className="h-7 w-7" strokeWidth={2} />
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-3">{feature.title}</h3>
                <p className="text-slate-600 leading-relaxed">{feature.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
